import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MenuAreaModel} from '../views/models/menu-area.model';
import {BehaviorSubject} from 'rxjs';
import {MenuSectionModel} from '../views/models/menu-section.model';
import {UserService} from './user.service';
import {environment} from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class MenuService {
  menu_change$ = new BehaviorSubject<MenuModel[]>([]);

  constructor(private httpClient: HttpClient,
              private userService: UserService) {
  }

  getMenu() {
    const user = this.userService.record_change$.getValue();
    if (user == undefined) {
      return;
    }
    if (user.role == 'admin' || user.role == 'hoteladmin') {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_area').subscribe(
        (areaDatas: MenuAreaModel[]) => {
          this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_section').subscribe(
            (sectionDatas: MenuSectionModel[]) => {
              const datas: MenuModel[] = [];
              for (const item of areaDatas) {
                const data = new MenuModel();
                data.area = item;
                data.sections = sectionDatas.filter(x => x.menu_area_id == item.id);
                data.sections.sort((a, b) => a.id - b.id);
                datas.push(data);
              }
              this.menu_change$.next(datas);
            },
            error => console.log(error)
          );
        },
        error => console.log(error)
      );
    } else {
      this.httpClient.get(environment.baseURL + '/v2/api' + '/menu_area').subscribe(
        (areaDatas: MenuAreaModel[]) => {
          this.httpClient.get(environment.baseURL + '/v2/api' + '/aside_menu').subscribe(
            (sectionDatas: MenuSectionModel[]) => {
              if (sectionDatas == null) {
                return;
              }
              const datas: MenuModel[] = [];
              for (const item of areaDatas) {
                const data = new MenuModel();
                data.area = item;
                data.sections = sectionDatas.filter(x => x.menu_area_id == item.id);
                data.sections.sort((a, b) => a.id - b.id);
                datas.push(data);
              }
              this.menu_change$.next(datas);
            },
            error => console.log(error)
          );
        },
        error => console.log(error)
      );
    }
  }
}

export class MenuModel {
  area: MenuAreaModel;
  sections: MenuSectionModel[];

  constructor(area = new MenuAreaModel(),
              sections = []) {
    this.area = area;
    this.sections = sections;
  }
}
